module.exports = __webpack_public_path__ + "img/gal_5.95e17250.png";